"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents the view model used for 'navigation' menu item
 */
var NavigationItem = /** @class */ (function () {
    function NavigationItem(icon, titleKey, routeLink, permissionKey, isVisible, isDefault, isConfigurable, isExternal, navBarType, children) {
        this.icon = icon;
        this.titleKey = titleKey;
        this.routeLink = routeLink;
        this.permissionKey = permissionKey;
        this.isVisible = isVisible;
        this.isDefault = isDefault;
        this.isConfigurable = isConfigurable;
        this.isExternal = isExternal;
        this.navBarType = navBarType;
        this.children = children;
        this.isSelected = false;
    }
    return NavigationItem;
}());
exports.NavigationItem = NavigationItem;
//# sourceMappingURL=nav-bar-item.model.js.map